const RESPONSIBLE_PRODUCER_COLUMNS = {
  id: 'Id',
  label: 'Label',
  tradeName: 'Trade name',
  countryCode: 'Country code',
  street: 'Street',
  postalCode: 'Postal code',
  city: 'City',
  email: 'Email',
  phoneNumber: 'Phone number',
  formUrl: 'Form URL',
} as const;

export default RESPONSIBLE_PRODUCER_COLUMNS;
